import(/* webpackMode: "eager" */ "/app/src/app/peatsense/MobileDesktopNotice.tsx")